import { NgClass } from '@angular/common';
import { Component, computed, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { selectLoggedInUser } from '@core/store/auth/auth.selectors';
import { FeatureFlagId } from '@api-types/enums/feature-flag-id.enum';
import { isFeatureFlagEnabled } from '@core/store/feature-flags/feature-flags.selectors';
import { Store } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';
import { ChatStateService } from '@components/chat/services/chat-state.service';
import { ChatRailComponent } from '@components/chat/components/chat-rail/chat-rail';
import { BasicLayoutHelperService } from './basic-layout-helper.service';
import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';
import { PageHeadingComponent } from './page-heading/page-heading.component';
import { SidebarComponent } from './sidebar/sidebar.component';

@Component({
  selector: 'pm-basic-layout',
  templateUrl: './basic-layout.component.html',
  imports: [
    RouterOutlet,
    HeaderComponent,
    SidebarComponent,
    FooterComponent,
    TranslateModule,
    PageHeadingComponent,
    NgClass,
    ChatRailComponent,
  ],
})
export class BasicLayoutComponent {
  private readonly store = inject(Store);
  private readonly basicLayoutHelperService = inject(BasicLayoutHelperService);

  protected readonly chat = inject(ChatStateService);
  protected readonly chatEnabled = this.store.selectSignal(
    isFeatureFlagEnabled(FeatureFlagId.scx_chat),
  );
  protected readonly chatOpen = computed(
    () => this.chatEnabled() && this.chat.isOpen(),
  );

  protected isHomePage = this.basicLayoutHelperService.isHomePage;

  protected user = this.store.selectSignal(selectLoggedInUser);

  protected backgroundIsTransparent = computed(() => {
    const navItem = this.basicLayoutHelperService.selectedNavItem();
    if (!navItem) {
      return false;
    }
    return navItem.transparentBackground ?? false;
  });
}
